// widgets/product-catalog-section/ui/cards/cardContract.ts
//
// Единый контракт всех шаблонов карточки каталога.
// Шаблоны — чистое представление: они ничего не знают про стор, корзину и избранное,
// только рисуют переданный товар и сообщают о кликах. Благодаря этому один и тот же
// компонент рендерится и в каталоге, и в превью раздела «Внешний вид» в админке.

import type { AppearanceCatalogConfig } from '@shared/config';

export interface ProductCardProps {
  /** Товар / группа / комбо из каталога. */
  item: any;
  /** Настройки каталога для текущей среды (сайт или приложение). */
  config: AppearanceCatalogConfig;
  /** Плейсхолдер заведения на случай товара без медиа. */
  placeholder?: string | null;
  /** Товар уже в корзине. */
  inCart?: boolean;
  /** Сколько штук уже в корзине — показывается на кнопке, чтобы состояние читалось с одного взгляда. */
  cartQuantity?: number;
  /** Показывать сердечко (гость авторизован и избранное включено в конфиге). */
  favoriteEnabled?: boolean;
  /** Проигрываемая анимация сердечка. */
  favoriteAnimation?: 'add' | 'remove' | null;
  /**
   * Карточка в первом экране: её фото грузится сразу и с высоким приоритетом.
   * Обычные карточки остаются на loading="lazy" — иначе браузер начнёт качать
   * всё меню разом и утопит LCP вместо того, чтобы его ускорить.
   */
  priority?: boolean;
  /**
   * Адрес страницы блюда. Название карточки становится настоящей ссылкой: по
   * <div> с обработчиком клика поисковик в карточку товара не попадёт, а гостю
   * ссылка даёт привычные «открыть в новой вкладке» и «скопировать адрес».
   * Пусто — заголовок остаётся текстом (превью в админке, товар без id).
   */
  href?: string;
}

export interface ProductCardEmits {
  /** Клик по карточке — открыть модалку товара. */
  (event: 'open'): void;
  /** Клик по кнопке «добавить». */
  (event: 'action'): void;
  /** Клик по сердечку. */
  (event: 'favorite'): void;
}

/** Значения по умолчанию для необязательных пропсов — одни на все шаблоны. */
export const PRODUCT_CARD_PROP_DEFAULTS = {
  placeholder: '',
  inCart: false,
  cartQuantity: 0,
  favoriteEnabled: false,
  favoriteAnimation: null,
  priority: false,
  href: '',
} as const;
